import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { combineLatest, map, Observable, of, startWith, Subscription, tap } from 'rxjs';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { MatStepper } from '@angular/material/stepper';
import { IFallbackValues, IMatchingColumn, IMatchingErrorsResponse, IOdoofield, IResponseMatching, IRowsErrorMessage, IRowsErrorsResponse } from 'src/app/features/imports/models/imports.models';
import { MatchingComparatorsColumns, MatchingComparatorsColumnsError, MatchingComparatorsColumnsSuccess, ReImportComparators, ReImportComparatorsSuccess, SetComparatorLoader } from '../../store/comparator.actions';
import { ComparatorService } from '../../services/comparator.services';
import { FormControl, Validators } from '@angular/forms';
import { ISupplier } from 'src/app/features/suppliers/models/suppliers.models';
import { AddSupplierError, AddSupplierSuccess, FetchSuppliers } from 'src/app/features/suppliers/store/suppliers.actions';
import { AddElementsComponent } from 'src/app/features/produits/components/add-elements/add-elements.component';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-upload-comparators-processing',
  templateUrl: './upload-comparators-processing.component.html',
  styleUrls: ['./upload-comparators-processing.component.scss']
})
export class UploadComparatorsProcessingComponent implements OnInit {

  @ViewChild('stepper') stepper: MatStepper | undefined;
  @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers!: QueryList<MatAutocompleteTrigger>;
  mode: ProgressBarMode = 'determinate';
  value = 79;
  fileReady: boolean = false;
  responseMatching$: Observable<IResponseMatching | null> = this.store.select((state) => state.comparators.responseMatching);
  responseMatching!: IResponseMatching;
  selectedValues: string[] = [];
  subscriptions: Subscription[] = [];
  matchingErrorsResponse: IMatchingErrorsResponse | null = null;
  rowsErrorsResponse: IRowsErrorsResponse | null = null;
  productsImport: any[] = [];
  columns: string[] = [];
  fields: string[] = [];
  name_create_enabled_fields: { [key: string]: boolean } = {};
  fallback_values: IFallbackValues = {};
  file_name!: string;
  showMoreErrors: boolean = false;
  expirationDate = new FormControl(
    new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().split('T')[0],
    Validators.required
  );
  suppliers$: Observable<ISupplier[]> = of([]);
  filteredSuppliers$!: Observable<ISupplier[]>;
  supplierControl = new FormControl('', Validators.required);
  supplier_id!: number;
  baseUrl = environment.BASE_URL_API;

  filteredFields: IOdoofield[] = [];
  constructor(
    private dialog: MatDialog,
    private store: Store<AppState>,
    private router: Router,
    private actions$: Actions,
    private cdr: ChangeDetectorRef,
    private services: ComparatorService
  ) { }

  ngOnInit(): void {
    const sub1 = this.responseMatching$.subscribe((res) => {
      if (res) {
        this.responseMatching = res;

        this.selectedValues = res.data.columns.map((column) => {
          const foundField = res.data.fields.find(
            (field) => column.toLocaleLowerCase() === field.string.toLocaleLowerCase()
          );
          return foundField ? foundField.name : '';
        });

        const { fields } = this.responseMatching.data
        this.filteredFields = fields.filter(f => !this.selectedValues.includes(f.name));
        this.file_name = res.data.file_name;
      } else {
        this.back();
      }
    });
    this.store.dispatch(FetchSuppliers({ page: { number: 1, size: 0 }}));
    this.suppliers$ = this.store.select((state) => state.suppliers.suppliers);

    const sub2 = this.actions$.pipe(
      ofType(MatchingComparatorsColumnsError),
      tap((action) => {
        if (action.responseMatching) {
          const response = action.responseMatching;
          if (this.isMatchingErrorsResponse(response)) {
            console.log('Matching errors response:', response);
            if (this.stepper) {
              this.stepper.reset();
              this.stepper.selectedIndex = 1;
              this.cdr.detectChanges();
            }
          } else if (this.isRowsErrorsResponse(response)) {
            console.log('Rows errors response:', response);
            if (this.stepper) {
              this.rowsErrorsResponse = response;
              this.matchingErrorsResponse = null;
              this.stepper.selectedIndex = 2;
              this.cdr.detectChanges();
            }
          }
        }
      })
    ).subscribe();

    const sub3 = this.actions$.pipe(
      ofType(MatchingComparatorsColumnsSuccess),
      tap((action) => {
        if(action.test && action.executeSeccess.preview.products) {
          this.rowsErrorsResponse = null
          this.productsImport = action.executeSeccess.preview.products;
          if(action.executeSeccess.matches) {
            this.columns = action.executeSeccess.matches.columns;
            this.fields = action.executeSeccess.matches.fields;
          }
          this.stepper!.selectedIndex = 2;
        }
        else if(!action.test) {
          this.back()
          // this.dialog.open(ImportationSucceedComponent,{
          //   data: this.productsImport
          // })
        }
      })).subscribe();

    const sub4 = this.actions$.pipe(
      ofType(ReImportComparatorsSuccess),
      tap((action) => {
          this.file_name = action.responseMatching.data.file_name
          this.testAndResolve()
      })).subscribe();

      const sub5 = this.actions$.pipe(
        ofType(AddSupplierSuccess),
        tap((action) => {
          if(action.supplier) {
            this.supplierControl?.setValue(action.supplier.name);
            this.supplier_id = action.supplier.id
          }
        })
      ).subscribe();

      const sub6 = this.actions$.pipe(
        ofType(AddSupplierError),
        tap(() => {
          this.supplierControl?.setValue('');
        })
      ).subscribe();

    this.filteredSuppliers$ = combineLatest([
      this.suppliers$,
      this.supplierControl!.valueChanges.pipe(
        startWith('')
      ),
    ]).pipe(
      map(([brands, input]) => this._filterStrings(brands, input!))
    );

    this.subscriptions.push(sub1, sub2, sub3, sub4, sub5);
  }

  private _filterStrings(strings: any[], value: string): any[] {
    const filterValue = this._normalizeValue(value);
    return strings.filter((string) =>
      this._normalizeValue(string.name)?.includes(filterValue!)
    );
  }
  private _normalizeValue(value: string | undefined): string | undefined {
    return value?.toLowerCase().replace(/\s/g, '');
  }

  ngAfterViewInit(): void {
    if (this.stepper) {
      this.stepper.selectedIndex = 1;
      console.log('ngAfterViewInit Current Step:', this.stepper.selectedIndex);
      this.cdr.detectChanges();
    }
  }

  onSupplierSelected(supplier: ISupplier) {
    if (supplier) {
      this.supplier_id = supplier.id
    }
  }

  addNewElement(newElementName: string, type: string, index?: number) {

    const dialogRef = this.dialog.open(AddElementsComponent, {
      data: {
        name: newElementName,
        type: type,
        index: index
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.autocompleteTriggers.forEach(trigger => trigger.closePanel());
    });
  }

  isMatchingErrorsResponse(
    response: IMatchingErrorsResponse | IRowsErrorsResponse
  ): response is IMatchingErrorsResponse {
    return Array.isArray((response as IMatchingErrorsResponse).messages) &&
      (response as IMatchingErrorsResponse).messages[0]?.not_matching_error !== undefined;
  }

  // Type guard for IRowsErrorsResponse
  isRowsErrorsResponse(
    response: IMatchingErrorsResponse | IRowsErrorsResponse
  ): response is IRowsErrorsResponse {
    return (response as IRowsErrorsResponse).ids !== undefined;
  }

  setSelectedValue(index: number, event: any) {
    const valueSelected = event.target.value;
    this.selectedValues = this.selectedValues.map((value: string, i: number) => {
      if (i !== index && value === valueSelected) {
        return '';
      }else {
        return value
      }
    })

    const { fields } = this.responseMatching.data
    this.filteredFields = fields.filter(f => !this.selectedValues.includes(f.name));
  }

  missedColomns(columns: string[], selected: string[]): number {
    const columnsLength = columns.length;
    const selectedLength = selected.filter((col) => col !== '').length;
    return columnsLength - selectedLength;
  }

  selectedColomnsPercentage(columns: string[], selected: string[]): number {
    const columnsLength = columns.length;
    const selectedLength = selected.filter((col) => col !== '').length;
    return (selectedLength / columnsLength) * 100;
  }

  isRelationError(field: string): boolean {
    return field ? field.endsWith('_id'): false;
  }

  setSolution(error: IRowsErrorMessage, event: any) {
    const value = event.target.value;
    if (value === 'create_new_values') {
      this.name_create_enabled_fields[error.field] = true;
      if (this.fallback_values[error.field]) {
        delete this.fallback_values[error.field];
      }
    } else {
      this.name_create_enabled_fields[error.field] = false;
      this.fallback_values[error.field] = {
        fallback_value: 'prevent',
        field_model: error.moreinfo.res_model,
        field_type: 'many2one'
      };
    }
  }

  testAndResolve(): boolean | void {
    if(this.expirationDate.invalid || !this.supplier_id || this.supplierControl.invalid) {
      this.expirationDate.markAsTouched();
      this.supplierControl.markAsTouched();
      return false
    }
    if (
      this.selectedValues.every(value => value !== null && value !== undefined) && this.selectedValues.length === this.responseMatching.data.columns.length
    ) {
      this.name_create_enabled_fields = Object.fromEntries(
        Object.entries(this.name_create_enabled_fields)
          .filter(([key, value]) => value === true)
      );
      const data: IMatchingColumn = {
        test: true,
        columns: this.responseMatching.data.columns,
        fields: this.selectedValues,
        name_create_enabled_fields: this.name_create_enabled_fields,
        fallback_values: this.fallback_values,
        sheet: this.responseMatching.data.sheet,
        sheets: this.responseMatching.data.sheets,
        expiration_date: this.expirationDate.value!,
        supplier_id: this.supplier_id
      };
      this.store.dispatch(MatchingComparatorsColumns({ id: this.responseMatching.id, matchingColumns: data }));
      this.selectedValues = [...this.selectedValues];
      this.name_create_enabled_fields = { ...this.name_create_enabled_fields };
      this.fallback_values = { ...this.fallback_values };
    }
    else {
      return false
    }
  }

  reaploadFile(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if(file){
        const formData = new FormData();
        formData.append('ufile', file ?? '');
        this.store.dispatch(ReImportComparators({id: this.responseMatching.id, file: formData}));
        }
    }
    event.target.value = '';
  }

  getBetterOffers(offers: any[], mainOffer: number): number{
    let betterOffers = 0;
    if(!offers || offers?.length === 0) return betterOffers;
    for (let i = 0; i < offers?.length; i++) {
      if (offers[i].price < mainOffer) {
        betterOffers++;
      }
    }
    return betterOffers;
  }

  // statistics
  getTotalBetterOffers(productsImport: any[]){
    let total = 0;
    productsImport.forEach(product => {
      if(product['price'] - product['actual_price'] < 0){
        total++;
      }
    });
    return total;
  }
  getTotalOthersBetterOffers(productsImport: any[]){
    let total = 0;
    productsImport.forEach(product => {
      total += this.getBetterOffers(product['other_imported_prices'], product['price']);
    });
    return total;
  }

  isLowestPrice(other_imported_prices: any[], item: any): boolean {
    if(!other_imported_prices || other_imported_prices?.length === 0) return true;

    return other_imported_prices.filter(product => product.id !== item.id).every((product: any) => product.price >= item.price);
  }

  downloadFile(comparatorFile: any) {
    this.store.dispatch(SetComparatorLoader({ isLoading: true }));
    this.services.getFileComparator(comparatorFile.id).subscribe({
      next: (res: {data: [], object: {file: string}}) => {
        this.store.dispatch(SetComparatorLoader({ isLoading: false }));
        const byteCharacters = atob(res?.object?.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = comparatorFile.file_name;
        link.click();
      },
      error: (err) => {
        this.store.dispatch(SetComparatorLoader({ isLoading: false }));
      }
    });
  }

  saveAsDraft(){
    this.back();
  }

  nextToPreview(): boolean | void{
    if(this.expirationDate.invalid) {
      this.expirationDate.markAsTouched();
      return false
    }
    this.stepper?.next()
  }

  commit() {
      const data: IMatchingColumn = {
        test: false,
        columns: this.responseMatching.data.columns,
        fields: this.selectedValues,
        sheet: this.responseMatching.data.sheet,
        sheets: this.responseMatching.data.sheets,
        name_create_enabled_fields: this.name_create_enabled_fields,
        expiration_date: this.expirationDate.value!,
        supplier_id: this.supplier_id
      };
      this.store.dispatch(MatchingComparatorsColumns({ id: this.responseMatching.id, matchingColumns: data, committed: true }));
      this.selectedValues = [...this.selectedValues];
  };

  back() {
    this.router.navigate(['comparators'], {
      queryParamsHandling: 'merge',
    })
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }
}
